import Select from "@/components/Select";
import React from "react";
import { Comparator, comparatorDefs, SerializedCondition } from "../types";
import Input from "@/components/Input";

export type UrlCondition = {
  url: string;
  comparator: Comparator;
};

export function UrlEditor({
  condition,
  onUpdate
}: {
  condition: SerializedCondition;
  onUpdate: (condition: SerializedCondition) => void;
}) {
  const urlCondition = JSON.parse(condition.data || "{}") as UrlCondition;

  function update(data: UrlCondition) {
    onUpdate({ ...condition, data: JSON.stringify(data) });
  }

  const validComparatorOptions: Record<string, string> = {
    equals: comparatorDefs.equals,
    notEquals: comparatorDefs.notEquals,
    contains: comparatorDefs.contains,
    notContains: comparatorDefs.notContains
  };

  return (
    <>
      <Select
        options={validComparatorOptions}
        value={urlCondition.comparator}
        onChange={(v) => update({ ...urlCondition, comparator: v })}
      />
      <Input
        className="w-full border rounded-md p-2"
        value={urlCondition.url}
        onChange={(v) => update({ ...urlCondition, url: v })}
      />
    </>
  );
}
